import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useStoreActions } from '~/store/store-context';
import { PracticeManagement } from '~/types/api.model';
import PMSetupPage from './PMSetupPage/PMSetupPage';
export const GetClientHubSetupTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            ClientHubSetupTID: {
                Root: 'client-hub-setup'
            }
        }
    });
export const ClientHubSetupPage = (param)=>{
    let { integration } = param;
    const { ClientHubSetupTID } = useMemo(()=>GetClientHubSetupTID(), []);
    const { api, fetchClientHubItems } = useStoreActions();
    return /*#__PURE__*/ _jsx(PMSetupPage, {
        testId: ClientHubSetupTID.Root(),
        pmName: PracticeManagement.ClientHub,
        doDisconnect: api.clientHub.disconnect,
        getItems: fetchClientHubItems,
        linkServiceTemplate: api.clientHub.linkServiceTemplate,
        integration: integration,
        getServiceTemplateIntegratedIds: (template)=>template.integrations.clientHubIntegratedIds()
    });
};
